import { createAsyncThunk } from '@reduxjs/toolkit';

import { IAbsenceBalanceDTO } from 'src/api/dtos';
import BalanceRepository from 'src/api/repositories/ess/v1/balance.repository';

export const fetchAbsenceBalances = createAsyncThunk<IAbsenceBalanceDTO[], void>(
  'absence-balances/balances',
  async (_, { rejectWithValue }) => {
    try {
      const repository = new BalanceRepository();
      return await repository.get();
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
